<template>
    <div class="dlParam comWDSParams_viewDP">
        <div class="com_param_div numViewConfig numViewConfig_unit">
            <div class="com_param_div">
                <div class="params_div">
                    <span class="span_til">图形宽度</span>
                    <el-input v-model="config.verticalWidth" @change="getRender" type="number" min="0"
                              :max="config.maxNum"></el-input>
                </div>
                <div class="params_div">
                    <div>上线最高为{{config.maxNum}},超出后平均分配宽度</div>
                </div>
            </div>
        </div>
        <!--        <div class="com_param_div">-->
        <!--            <div class="params_div">-->
        <!--                <span>数据堆叠</span>-->
        <!--                <el-input v-model="config.stack" @change="getRender" placeholder="请输入数据堆叠类型"></el-input>-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <div class="com_param_div">-->
        <!--            <div class="params_div checkViewConfig">-->
        <!--                <el-checkbox v-model="config.customColor" @change="getColor">自定义颜色</el-checkbox>-->
        <!--            </div>-->
        <!--            <div class="params_div" v-if="config.customColor">-->
        <!--                <span>颜色</span>-->
        <!--                <el-color-picker v-model="config.color" show-alpha @change="getRender"></el-color-picker>-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <div class="com_param_div">-->
        <!--            <div class="params_div checkViewConfig">-->
        <!--                <el-checkbox v-model="config.label.show" @change="getRender">是否展示数值</el-checkbox>-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <div class="com_param_div" v-if="nowChart.name==='双轴图'">-->
        <!--            <div class="params_div selViewConfig ">-->
        <!--                <span class="span_til">主次轴</span>-->
        <!--                <el-select v-model="config.lTAxis" placeholder="请选择位置"-->
        <!--                           :popper-append-to-body="false" @change="getRender">-->
        <!--                    <el-option-->
        <!--                            v-for="item in lTAxisList"-->
        <!--                            :key="item.value"-->
        <!--                            :label="item.label"-->
        <!--                            :value="item.value">-->
        <!--                    </el-option>-->
        <!--                </el-select>-->
        <!--            </div>-->
        <!--        </div>-->


        <!--        <div class="com_param_div">-->
        <!--            <div class="params_div selViewConfig ">-->
        <!--                <span class="span_til">图表类型</span>-->
        <!--                <el-select v-model="config.type" placeholder="请选择图表类型"-->
        <!--                           :popper-append-to-body="false" @change="getRender">-->
        <!--                    <el-option-->
        <!--                            v-for="item in typeList"-->
        <!--                            :key="item.value"-->
        <!--                            :label="item.label"-->
        <!--                            :value="item.value">-->
        <!--                    </el-option>-->
        <!--                </el-select>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 10:48 上午
     */
    export default {
        name: 'dlParam',
        components: {},
        props: {
            index: {
                type: Number,
                default: 0
            },
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.dlList[this.index].params || {};
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.dlList[this.index].params || {};
                }
            },
            nowChart() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.nowChart;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart;
                }
            }
        },
        data() {
            return {
                lTAxisList: [
                    {value: 0, label: '主轴'},
                    {value: 1, label: '次轴'}
                ],
                typeList: [
                    {value: 'bar', label: '柱状图'},
                    {value: 'line', label: '折线图'}
                ]
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
            //颜色
            getColor() {
                if (!this.config.customColor) {
                    this.getRender();
                    this.config.color = '';
                }
            }
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .dlParam {

    }
</style>
